// removed by extract-text-webpack-plugin
module.exports = {"errorText":"index__errorText___2W_AK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ErrorText/index.less
// module id = 1088
// module chunks = 3